import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton } from '@material-ui/core';
import { Add as AddIcon, Remove as RemoveIcon } from '@material-ui/icons';
import SingleSelectorField from './SingleSelectorField';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const MultiSelector = ({
  selectors = [],
  onChange,
  label,
  helperText,
  disabled,
}) => {
  const t = useLocalizedMessage();
  const values = selectors.length > 0 ? selectors : [''];
  const inputIdPrefix = `kea-selector-${String(label || 'value')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')}`;

  const handleUpdate = (index, newValue) => {
    const newSelectors = [...values];
    newSelectors[index] = newValue;
    onChange(newSelectors);
  };

  const handleAdd = () => {
    onChange([...values, '']);
  };

  const handleRemove = (index) => {
    const newSelectors = values.filter((_, i) => i !== index);
    onChange(newSelectors);
  };

  return (
    <Box>
      {values.map((val, index) => (
        <Box key={index} display="flex" alignItems="flex-start" mb={2} mt={1}>
          <Box flex={1}>
            <SingleSelectorField
              id={`${inputIdPrefix}-${index}`}
              value={val}
              onChange={(e) => handleUpdate(index, e.target.value)}
              label={index === 0 ? label : undefined}
              placeholder={t(index === 0 ? 'search.settings.selectors.example' : 'search.settings.selectors.additional')}
              disabled={disabled}
              helperText={index === values.length - 1 ? helperText : undefined}
            />
          </Box>

          <Box ml={1} display="flex" alignItems="center" height={56}>
            {values.length > 1 && (
              <IconButton onClick={() => handleRemove(index)} size="small" style={{ color: '#f44336' }}>
                <RemoveIcon />
              </IconButton>
            )}

            {index === values.length - 1 && (
              <IconButton onClick={handleAdd} size="small" color="primary">
                <AddIcon />
              </IconButton>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

MultiSelector.propTypes = {
  selectors: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node,
  helperText: PropTypes.node,
  disabled: PropTypes.bool,
};

export default MultiSelector;
